import { styled } from '@mui/material/styles';
import { DateTimePicker } from '@mui/x-date-pickers';
import { Box, Typography } from '@mui/material';

export const TimeRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  width: '100%',
  borderBottom: '0.5px solid var(--Separators-Non-opaque---Dark, rgba(84, 84, 88, 0.65))',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: theme.spacing(2),
  gap: '10px',
  height: 'auto',

  '&.last-element': {
    borderBottom: 'none',
  },
}));

export const TimeInfo = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  width: '60%',
});

export const StatusText = styled(Typography)(({ status = 'info', theme }) => {
  switch (status) {
    case 'info':
      return { color: theme.palette.info.main };
    case 'success':
      return { color: theme.palette.success.main };
    case 'warning':
      return { color: theme.palette.warning.main };
    case 'error':
      return { color: theme.palette.error.main };
    default:
      return { color: theme.colors.gray };
  }
});

export const CustomDateTimePicker = styled(DateTimePicker)(({ isCompleted, theme }) => ({
  '& .MuiInputBase-root.MuiOutlinedInput-root': {
    color: theme.palette.info.main,
    borderRadius: '6px',
    justifySelf: 'center',
    width: '105px',
    height: '38px',
    padding: '0',
    fontSize: '17px',
    background: isCompleted ? 'transparent' : 'rgba(118, 118, 128, 0.24)',
  },
}));

export const CompleteText = styled(Typography)(({ styledcolor }) => ({
  color: styledcolor,
}));

export const ErrorText = styled(Typography)(({ theme, styledcolor }) => ({
  color: theme.colors.red || styledcolor,
  width: '90%',
}));
